import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const deleteFile = createAsyncThunk(
  "initiatives/deleteFile",
  async (fileId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}api/initiatives/files/${fileId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.token}`,
          },
        }
      );
      if (!response.data?.success) {
        return rejectWithValue(response.data?.message || "Failed to delete file");
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to delete file");
    }
  }
);
